import constants, { ACCESS_TOKEN, HTTP_METHODS } from "../../../settings/shared/constants"
import axiosClient from "../../common"

function _constructHeader() {
    let jwtToken = localStorage.getItem(ACCESS_TOKEN);
    let headers = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + jwtToken
    }
    return headers;
}

function getuserdetails() {
    return axiosClient({
        url: constants.api.user.get_user,
        method: HTTP_METHODS.GET,
        headers: _constructHeader(),
    })
}

function updatePassword(postData) {
    return axiosClient({
        url: constants.api.usermanagement.updatePassword,
        method: HTTP_METHODS.POST,
        headers: _constructHeader(),
        data: postData
    })
}


//To export run function
const UserService = {
    getuserdetails, updatePassword
}
export default UserService;
